var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47,
    height: 46,
    viewBox: "0 0 47 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\u041E\\u0431\\u044A\\u0435\\u0434\\u0438\\u043D\\u0435\\u043D\\u0438\\u0435_19",
    "data-name": "\\u041E\\u0431\\u044A\\u0435\\u0434\\u0438\\u043D\\u0435\\u043D\\u0438\\u0435 19",
    d: "M22.889,45A22.747,22.747,0,0,1,0,22.391,22.759,22.759,0,0,1,23.111,0,22.749,22.749,0,0,1,46,22.609,22.757,22.757,0,0,1,23,45ZM2.3,22.4A20.474,20.474,0,0,0,22.9,42.75,20.485,20.485,0,0,0,43.7,22.6,20.474,20.474,0,0,0,23.1,2.25H23A20.483,20.483,0,0,0,2.3,22.4ZM22.908,40.95A18.653,18.653,0,0,1,4.14,22.411,18.663,18.663,0,0,1,23.091,4.051,18.653,18.653,0,0,1,41.86,22.59,18.659,18.659,0,0,1,23,40.95Zm1.853-2.57a16.163,16.163,0,0,0,14.454-14l-3.708-.018a12.427,12.427,0,0,1-7.272,9.407l.047-9.553,4.6.022.016-3.375-4.6-.022.048-9.552a12.416,12.416,0,0,1,7.178,9.475l3.709.018A16.153,16.153,0,0,0,24.918,6.639ZM6.67,22.423a16.1,16.1,0,0,0,14.411,15.94l.158-31.742A16.109,16.109,0,0,0,6.67,22.423Zm3.679.018a12.367,12.367,0,0,1,7.416-11.205l-.111,22.481A12.36,12.36,0,0,1,10.349,22.44Z",
    transform: "translate(0.5 0.5)",
    fill: "#009cbd",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDe);
export default __webpack_public_path__ + "static/media/de.8eb98ad7b58737f8e038fb62a9be4a89.svg";
export { ForwardRef as ReactComponent };